import { Pipe, PipeTransform } from '@angular/core';
import { Supplier } from '@generated/models';

@Pipe({
  name: 'supplierLink',
})
export class SupplierLinkPipe implements PipeTransform {
  transform(value: { id: string; kind: Supplier['kind'] }, ...args: string[]): string[] {
    return supplierLink(value, args);
  }
}

export const supplierLink = (supplier: Pick<Supplier, 'id' | 'kind'>, childRoutes: string[] = []): string[] => {
  const routes: Record<Supplier['kind'], string> = {
    company: 'company',
    freelance: 'freelance',
  };
  return ['/', 'suppliers', routes[supplier.kind], supplier.id, ...childRoutes];
};
